import { render, staticRenderFns } from "./BaseCheckboxButtons.vue?vue&type=template&id=f7e6dbe2&scoped=true"
import script from "./BaseCheckboxButtons.vue?vue&type=script&lang=js"
export * from "./BaseCheckboxButtons.vue?vue&type=script&lang=js"
import style0 from "./BaseCheckboxButtons.vue?vue&type=style&index=0&id=f7e6dbe2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7e6dbe2",
  null
  
)

export default component.exports